'use client';

import type { ReactNode } from 'react';
import { PrimaryButton } from 'components/shared/PrimaryButton';
import { DotSpinner } from 'components/shared/DotsSpinner';
import { useBuyCheckout } from '../../state/useBuyCheckout';
import { useBuyContext } from '../../state/BuyContext';
import styles from './CheckoutButton.module.css';

export type CheckoutButtonProps = {
  isEnabled?: () => boolean;
  onDisabledClick?: () => void;
  children?: ReactNode;
  productLabel?: string;
};

export const CheckoutButton = ({
  isEnabled,
  onDisabledClick,
  children = 'Add to Cart',
  productLabel,
}: CheckoutButtonProps) => {
  const { productName, baseVariantId } = useBuyContext();
  const { checkout, isLoading } = useBuyCheckout();

  const enabled = isEnabled ? isEnabled() : true;
  const disabled = isLoading || !enabled;

  return (
    <div
      className={styles.wrapper}
      data-disabled={disabled ? 'true' : 'false'}
      onClick={!enabled ? onDisabledClick : undefined}
    >
      <PrimaryButton
        type="button"
        data-buttontype="add to cart"
        data-product={productLabel ?? productName}
        data-variantid={baseVariantId ?? ''}
        onClick={checkout}
        disabled={disabled}
        aria-busy={isLoading}
      >
        {isLoading ? <DotSpinner color="#000000" /> : children}
      </PrimaryButton>
    </div>
  );
};
